<template>
  <svg @click='click()' id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.11 63.11">
    <path class="cls-1" d="M404.12,350.55a31.56,31.56,0,1,0-31.56,31.55,31.56,31.56,0,0,0,31.56-31.55" transform="translate(-341.01 -318.99)"/>
    <g v-if='!active'>
      <rect class="cls-2" x="16.9" y="19.13" width="29.31" height="1.59"/>
      <rect class="cls-2" x="16.9" y="41.64" width="29.31" height="1.59"/>
      <rect class="cls-2" x="16.9" y="30.39" width="29.31" height="1.59"/>
    </g>
    <g v-if='active'>
      <rect class="cls-2" x="16.9" y="30.39" width="29.31" height="1.59" transform="rotate(-45)" transform-origin="50% 50%"/>
      <rect class="cls-2" x="16.9" y="30.39" width="29.31" height="1.59" transform="rotate(45)" transform-origin="50% 50%"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: ['active'],
  methods: {
    click(){
      this.$emit("update:active", !this.active)
    }
  }
}
</script>

<style scoped>
  svg {
    cursor: pointer;
    width: 3.5rem;
    transition: transform 0.1s ease-in;
  }
  svg:hover {
    transform: scale(1.05);
  }
  .cls-1{fill:var(--gray);}
  .cls-2{fill:var(--white);}
</style>
